<template>
  <v-container>
    <v-row>
      <v-col>
        <div class="mt-4">
          <v-btn
            v-for="{ locale } of locales"
            :key="locale"
            icon
            @click="setLocale(locale)"
          >
            {{ locale }}
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import localeMixin from '@/mixins/locale.mixin'
import snackbarMixin from '@/mixins/snackbar.mixin'
import pageMixin from '@/mixins/page.mixin'


export default {
  mixins: [
    localeMixin,
    snackbarMixin,
    pageMixin
  ],


  async created () {
    try {
      this.setPageTitle(this.$t('nav.accountSettings'))
    } catch (error) {
      this.showSnackbarError()
      this.$log.error(error)
    }
  }
}
</script>
